import { SLoader } from "@avalara/skylab-sdk/react";
import classnames from "classnames";
import React from "react";

import { testIDs } from "../../../end-to-end-tests/constants/testIDs";

import "./record-count.css";

/**
 * RecordCount component displays the count of records in a search result.
 * When isLoading is true, a Skylab loader is shown to indicate the count is loading.
 *
 * @param {Object} props - Component props
 * @param {number} props.selectedCount - Number of selected records
 * @param {string|number} props.recordCount - Total count of records
 * @param {string} props.recordName - Name of the records (e.g., "certificates")
 * @param {boolean} [props.isLoading] - Whether the count is still loading
 */
const RecordCount = React.memo(props => {
    const selected = props.selectedCount !== 0;

    const recordCountClass = classnames({
        "margin-bottom-xs": true,
        "margin-top-sm": props.hasFilterChips || (!props.hasFilterChips && props.usesFilterChips),
        "text-right": true,
        "record-count": true,
        "top-negative-20": props.hasFilterChips,
    });

    // Show Skylab loader while count is being fetched
    if (props.isLoading) {
        return (
            <div className="" data-testid={testIDs.shared.recordCount}>
                <div id="record-count" className="margin-bottom-xs text-right">
                    <SLoader className="small" loading />
                </div>
                <span className="clear" />
            </div>
        );
    }

    const counterText = selected ? (
        <div id="selected-record-count" className="margin-bottom-xs">
            <span className="clear" />
            <span className="left no-wrap">{`${props.selectedCount} selected`}</span>
            <span className="right no-wrap">
                {props.recordCount} {props.recordName}
            </span>
        </div>
    ) : (
        <>
            <span className={recordCountClass} data-testid={testIDs.shared.recordCount}>
                {props.recordCount} {props.recordName}
            </span>
            <span className="clear" />
        </>
    );

    return <React.Fragment>{counterText}</React.Fragment>;
});

export default RecordCount;
